import { createTRPCReact } from "@trpc/react-query";
import type { inferRouterOutputs } from "@trpc/server";
import type { AppRouter } from "@foto/api/router";

export const trpc = createTRPCReact<AppRouter>();

/**
 * Saídas dos procedimentos, para tipar props sem redeclarar o formato.
 *
 * Derivar do hook — `ReturnType<typeof trpc.x.useQuery>["data"]` — não funciona:
 * fora de um componente o genérico não se instancia e o TypeScript chega a `{}`.
 */
export type SaidaRota = inferRouterOutputs<AppRouter>;
